/// <reference path="../../polaris-web-components.d.ts" />
import React from 'react';
import CustomProgressBar from './CustomProgressBar';
import ImportNotification from './ImportNotification';

export default function ImportProcessing({ bulkStatus, uploadStatus, pollingResult, setErrModalActive, processingMsg, catalogExtractMsg, collectionProcessingStep, stagedUploadProgress, splitItems, productsQuery, productDeleteStatus, metaDeleteStatus, bulkCancelStatus, cancelBulk, generateProductErrorModal, generateMetafieldErrorModal,generateUploadWarningsModal,mapping,fileParse,processingProgress,emailMarketingUpdate, backupStatus, backupProgress,isCustomerImport }) {
    
    // Render backup notification if backup is in progress, completed, or errored
    if (backupStatus) {
        const isCompleted = backupStatus === 'completed';
        const isError = backupStatus === 'error';
        const isInProgress = !isCompleted && !isError;
        
        return (
          <s-box paddingBlockStart="base">
            <s-section padding="base">
              <s-table selectable={false}>
                <s-table-body>
                  <s-table-row>
                    <s-table-cell>
                      <s-stack direction="inline" gap="small" alignment="leading">
                        {isInProgress && <s-spinner size="small" />}
                        <s-badge tone={isError ? "critical" : isCompleted ? "success" : "info"}>
                          {isCompleted ? "Backup completed" : isError ? "Backup failed" : "Backing up products"}
                        </s-badge>
                      </s-stack>
                    </s-table-cell>
                    
                    <s-table-cell style={{ textAlign: 'right', width: '100%' }}>
                      <s-stack direction="inline" gap="small" alignment="trailing">
                        <s-text>{backupProgress?.message || backupStatus}</s-text>
                        {backupProgress?.progress !== undefined && isInProgress && (
                          <>
                            <s-text>{backupProgress.progress}%</s-text>
                            <div style={{ width: "125px" }}>
                              <CustomProgressBar progress={backupProgress.progress} />
                            </div>
                          </>
                        )}
                        {backupProgress?.productsProcessed !== undefined && (
                          <s-text>
                            Products: <s-text type="strong">{backupProgress.productsProcessed}/{backupProgress.totalProducts}</s-text>
                          </s-text>
                        )}
                        {backupProgress?.batchNumber !== undefined && isInProgress && (
                          <s-text>
                            Batch: <s-text type="strong">{backupProgress.batchNumber}/{backupProgress.totalBatches}</s-text>
                          </s-text>
                        )}
                      </s-stack>
                    </s-table-cell>
                  </s-table-row>
                </s-table-body>
              </s-table>
            </s-section>
            </s-box>
        );
    }
    
    if (uploadStatus) {
        if (pollingResult !== undefined) {
            return (
              
                <ImportNotification
                    item={pollingResult}
                    bulkCancelStatus={bulkCancelStatus}
                    cancelBulk={cancelBulk}
                    generateProductErrorModal={generateProductErrorModal}
                    generateMetafieldErrorModal={generateMetafieldErrorModal}
                    generateUploadWarningsModal={generateUploadWarningsModal}
                    emailMarketingUpdate={emailMarketingUpdate}
                    isCustomerImport={isCustomerImport}
                />
            )
        }
        else if (bulkStatus === "validating" || bulkStatus === "processing" || bulkStatus === "failed" || bulkStatus === "deleting" || bulkStatus ==="fileparsing"
        || bulkStatus === "mapping") { 
            return (
              <s-box paddingBlockStart="base">
                <s-section padding="base">
                  <s-table selectable={false}>
                    <s-table-body>
                      <s-table-row>
                        <s-table-cell>
                          <s-stack direction="inline" gap="small" alignment="leading">
                            {bulkStatus !== "failed" ? <s-spinner size="small" /> : null}
                            <s-badge tone={bulkStatus === "failed" ? "critical" : "info"}>
                              {bulkStatus === "fileparsing" ? "File Parsing" : bulkStatus}
                            </s-badge>
                          </s-stack>
                        </s-table-cell>
                        
                        <s-table-cell style={{ textAlign: 'right', width: '100%' }}>
                          {bulkStatus === "failed" ? (
                            <s-link onClick={() => setErrModalActive(true)}>
                              <s-text tone="critical">errors</s-text>
                            </s-link>
                          ) : (
                            <>
                              {processingMsg === "Catalog extract" ? (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', width: '100%' }}>
                                  <s-text>Convert to Shopify format</s-text>
                                  <s-text type="strong">{catalogExtractMsg.status}</s-text>
                                </div>
                              ) : null}

                              {processingMsg === "CollectionProcessingStep" ? (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', width: '100%' }}>
                                  <s-spinner size="small" />
                                  <s-text>{collectionProcessingStep?.message}</s-text>
                                </div>
                              ) : null}
                    
                              {["uploading", "customeruploading", "metaobjectuploading"].includes(processingMsg) ? (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', width: '100%' }}>
                                  <s-text>preparing to upload: {stagedUploadProgress.progress}/100%</s-text>
                                  <div style={{ width: "125px" }}>
                                    <CustomProgressBar progress={stagedUploadProgress.progress} />
                                  </div>
                                </div>
                              ) : null}
                    
                              {processingMsg === "progress" ? (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', width: '100%' }}>
                                  <s-text>Processing: {processingProgress !== null && processingProgress !== undefined ? processingProgress : 0}%</s-text>
                                  <div style={{ width: "125px" }}>
                                    <CustomProgressBar progress={processingProgress !== null && processingProgress !== undefined ? processingProgress : 0} />
                                  </div>
                                </div>
                              ) : null}
                    
                              {["Products", "Variants", "Images/Metafields/Tags"].includes(processingMsg) ? (
                                <s-stack direction="inline" gap="small" alignment="trailing">
                                  <s-text>{processingMsg}</s-text>
                                  <s-text type="strong">{mapping.progress}</s-text>
                                </s-stack>
                              ) : null}
                    
                              {processingMsg === "fileparsing" ? (
                                <s-stack direction="inline" gap="small" alignment="trailing">
                                  <s-text>Rows scanned</s-text>
                                  <s-text type="strong">{fileParse.progress}</s-text>
                                </s-stack>
                              ) : null}
                    
                              {["Split products", "Split customers", "Split metaobjects"].includes(processingMsg) ? (
                                <s-stack direction="inline" gap="small" alignment="trailing">
                                  <s-text>Update: <s-text type="strong">{splitItems?.update}</s-text></s-text>
                                  <s-text>Create: <s-text type="strong">{splitItems?.create}</s-text></s-text>
                                  <s-text>Delete: <s-text type="strong">{splitItems?.productDelete}</s-text></s-text>
                                </s-stack>
                              ) : null}
                    
                              {processingMsg === "Split metafields" ? (
                                <s-stack direction="inline" gap="small" alignment="trailing">
                                  <s-text>Metafield update: <s-text type="strong">{splitItems?.metafield}</s-text></s-text>
                                  <s-text>Metafield to Delete: <s-text type="strong">{splitItems?.metaDelete}</s-text></s-text>
                                </s-stack>
                              ) : null}
                    
                              {processingMsg === "Query products" ? (
                                <s-stack direction="inline" gap="small" alignment="trailing">
                                  <s-text>Status: <s-text type="strong">{productsQuery?.status}</s-text></s-text>
                                </s-stack>
                              ) : null}
                    
                              {processingMsg === "Product delete" ? (
                                <s-stack direction="inline" gap="small" alignment="trailing">
                                  <s-text>{productDeleteStatus.status}</s-text>
                                  <s-text type="strong">{productDeleteStatus.progress}</s-text>
                                </s-stack>
                              ) : null}
                    
                              {processingMsg === "Metafield delete" ? (
                                <s-stack direction="inline" gap="small" alignment="trailing">
                                  <s-text>{metaDeleteStatus.status}</s-text>
                                  <s-text type="strong">{metaDeleteStatus.progress}</s-text>
                                </s-stack>
                              ) : null}
                    
                              {![
                                "Split products",
                                "Split customers", 
                                "Split metaobjects",
                                "Query products",
                                "Split metafields",
                                "uploading",
                                "customeruploading",
                                "metaobjectuploading",
                                "Catalog extract",
                                "CollectionProcessingStep",
                                "Product delete",
                                "Metafield delete",
                                "Images/Metafields/Tags",
                                "Products",
                                "Variants",
                                "progress",
                                "fileparsing",
                              ].includes(processingMsg) ? (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                                  <s-text>
                                    {processingMsg === "validating" || processingMsg === "fileparsing"
                                      ? "parsing the file"
                                      : processingMsg}
                                  </s-text>
                                </div>
                              ) : null}
                            </>
                          )}
                        </s-table-cell>
                      </s-table-row>
                    </s-table-body>
                  </s-table>
                </s-section>
                </s-box>
              );
        }
    }
}